import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import AndroidIcon from "@mui/icons-material/Android";
import AppleIcon from "@mui/icons-material/Apple";
import { cls } from "../../hatim/soft/SoftKit";
import { useScriptMode } from "../../../contexts/ScriptModeContext";
import { useAuth } from "../../../contexts/AuthContext";
import { useGetDeviceStatsQuery } from "../../../api/notificationApi";

function Stat({ label, value, tone = "default", Icon }) {
  const tones = {
    default: "text-terakkiPrimaryDark dark:text-[#8FC9CA]",
    muted: "text-terakkiNeutral dark:text-white/70",
  };
  return (
    <div className="flex-1 min-w-[96px] px-3 py-2 border-l border-terakkiBorder first:border-l-0 dark:border-white/[0.14]">
      <div className="flex items-center gap-1.5 text-xs text-terakkiNeutral dark:text-white/70">
        {Icon && <Icon sx={{ fontSize: 15 }} aria-hidden />}
        {label}
      </div>
      <div className={`text-2xl font-Default leading-tight mt-0.5 ${tones[tone]}`}>{value}</div>
    </div>
  );
}

/**
 * Kayıtlı cihaz özeti. Yalnızca Admin görür — veri tüm kullanıcıları
 * kapsadığı için sunucu da bu ucu Admin'e kilitliyor; burada gizlemek
 * sadece gereksiz 403 isteğini önlüyor.
 */
export default function DeviceStatsCard() {
  const { t } = useScriptMode();
  const { user } = useAuth();
  const isAdmin = user?.role === "Admin";
  const { data, isLoading, isError } = useGetDeviceStatsQuery(undefined, { skip: !isAdmin });

  if (!isAdmin) return null;

  const d = data?.data?.devices;
  const total = (d?.active || 0) + (d?.inactive || 0);

  return (
    <div className={`${cls.panel} overflow-hidden`}>
      <div className="flex items-center gap-2.5 px-4 py-3 bg-terakkiBrandCloud border-b border-terakkiBrandMist dark:bg-white/[0.06] dark:border-white/[0.14]">
        <span className="w-9 h-9 rounded-full bg-terakkiBrandCloud text-terakkiPrimaryDark flex items-center justify-center shrink-0 dark:bg-white/10 dark:text-[#8FC9CA]">
          <PhoneIphoneIcon aria-hidden />
        </span>
        <div className="min-w-0 flex-1">
          <div className="text-lg font-SemiBold text-terakkiPrimaryDark leading-tight dark:text-white">
            {t("notif_dev_heading")}
          </div>
          <div className="text-xs text-terakkiNeutral leading-tight dark:text-white/70">
            {t("notif_dev_hint")}
          </div>
        </div>
      </div>

      <div className="p-4">
        {isLoading ? (
          <div className="flex gap-2">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="flex-1 h-16 rounded-xl bg-terakkiSurfaceAlt animate-pulse dark:bg-white/[0.08]" />
            ))}
          </div>
        ) : isError ? (
          <p className="text-sm text-terakkiNeutral dark:text-white/70">{t("notif_history_load_error")}</p>
        ) : total === 0 ? (
          <p className="text-sm text-terakkiNeutral dark:text-white/70">{t("notif_dev_none")}</p>
        ) : (
          <>
            <div className="flex flex-wrap gap-2">
              <Stat label={t("notif_dev_active")} value={d.active} />
              <Stat label={t("notif_dev_ios")} value={d.byPlatform?.ios ?? 0} Icon={AppleIcon} />
              <Stat
                label={t("notif_dev_android")}
                value={d.byPlatform?.android ?? 0}
                Icon={AndroidIcon}
              />
              <Stat label={t("notif_dev_inactive")} value={d.inactive} tone="muted" />
            </div>
            {d.lastSeenAt && (
              <p className="text-xs text-terakkiNeutral mt-3 dark:text-white/70">
                {t("notif_dev_last_seen")}: {new Date(d.lastSeenAt).toLocaleString("tr-TR")}
              </p>
            )}
            {d.inactive > 0 && (
              <p className="text-xs text-terakkiNeutral mt-1 dark:text-white/70">{t("notif_dev_inactive_hint")}</p>
            )}
          </>
        )}
      </div>
    </div>
  );
}
